import {
  FETCH_NOTIFY_SUCCEED,
} from '../actions/notify/action_types';

export default (state = {
  notifies: [],
}, action) => {
  switch (action.type) {
    case FETCH_NOTIFY_SUCCEED:
      return {
        ...state,
        notifies: action.data,
      };
    default:
      return {
        ...state,
      };
  }
};
